<template style="">
  <div class="Video_release"  v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-form label-width="80px" style="padding-top: 20px;">
      <el-form-item label="图片标题">
        <el-input style="width: 300px;" v-model="MaterialName" placeholder="请输入图片标题（5-30个汉字）"></el-input>
      </el-form-item>

      <el-form-item label="上传图片" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：2.35:1</p>
      </el-form-item>

      <el-form-item label="栏目">
        <el-select v-model="ItemKey" placeholder="请选择栏目">
          <el-option v-for="(item,index) in columnList" :key="index" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="定时发送">
        <el-radio-group v-model="timisngs">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="timisngs == '2'" label="定时时间">
        <el-date-picker  v-model="ScheduledRelease" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"  type="datetime" placeholder="选择日期时间" :picker-options="pickerOptions" @change="handleDateTimeChange">
          </el-date-picker>
      </el-form-item>


  
      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="(item,index) in tagList" :key="index" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="ue">
        <div class="editor-container">
          <UE :defaultMsg=defaultMsg :config=config ref="ue"></UE>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit(1)">立即修改</el-button>
      </el-form-item>
    </el-form>

    <el-dialog  title="封面裁剪"  :visible.sync="Croppdialog"  :close-on-click-modal="false"  :close-on-press-escape="false"  :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview" />
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import UE from '@/components/text.vue';
import PictureCropper from '@/components/pictureCropper.vue'

export default {
  components: { UE,PictureCropper},
  data() {
    return { 
      timisngs:'1',
      ScheduledRelease:'',

      materialKey: '',
      loading:false,
      videopd:false,
      videourl: '',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      MaterialName: "",//视频标题
      Label: [],//标签
      ItemKey: "1",//栏目
      img: "",
      imageUrl: '',
      tagList:[],//标签列表
      columnList: [],//栏目列表
      defaultMsg: '',
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 350
      },

      // 裁剪
      Croppdialog:false,
      previews: {},
      cropperHeight: '600px',  // 裁剪图片容器高度
      cropperWidth: '600px',   // 裁剪图片容器宽度
      autoCropWidth: 200,
      autoCropHeight: 200
    }
  },
  // ==== 新增计算属性 ====
  computed: {
    pickerOptions() {
      return {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        selectableRange: this.getSelectableRange(),
        // onPick: ({ date }) => {
        //   if (date) {
        //     this.$nextTick(() => {
        //       this.handleDateSelection(date);
        //     });
        //   }
        // }
      };
    }
  },
  mounted() {
    var _this = this;
    this.materialKey = [this.$route.query.materialKey][0];
    this.$Http_Post('management/tagList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.tagList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/columnList').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.columnList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/getContentDetails', { MaterialKey: this.materialKey }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.videopd = true;
        this.imageUrl = res.Data.materialCover;
        this.MaterialName = res.Data.materialName;
        this.Label = res.Data.labeles;
        this.ItemKey = res.Data.itemKey.toString();
        this.defaultMsg = res.Data.richTextContent;
        if(res.Data.scheduledRelease){
          this.timisngs = '2';
          this.ScheduledRelease = res.Data.scheduledRelease;
        }
      } else {
        this.Global.request_failure(res.Message);
      }
    })

  },
  methods: {
    // ==== 新增：日期选择处理 ====
    handleDateSelection(date) {
      const now = new Date();
      const selected = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selected.setHours(0, 0, 0, 0);
      
      let newDateTime;
      
      if (selected.getTime() === today.getTime()) {
        // 选择今天，直接使用当前时间
        newDateTime = new Date();
      } else {
        // 选择未来日期，设置为上午9点
        newDateTime = new Date(date);
        newDateTime.setHours(9, 0, 0, 0);
      }
      
      this.ScheduledRelease = newDateTime;
    },

    // ==== 新增：获取可选择的时间范围 ====
    getSelectableRange() {
      const now = new Date();
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (!this.ScheduledRelease || this.timisngs !== '2') {
        return ['00:00:00 - 23:59:59'];
      }
      
      try {
        const selectedDate = new Date(this.ScheduledRelease);
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        
        if (selectedDay.getTime() === today.getTime()) {
          const currentHour = now.getHours();
          const currentMinute = now.getMinutes();
          
          let startHour = currentHour;
          let startMinute = currentMinute;
          
          const startTime = `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}:00`;
          return [`${startTime} - 23:59:59`];
        }
      } catch (error) {
        console.warn('日期解析错误:', error);
      }
      
      return ['00:00:00 - 23:59:59'];
    },
    // ==== 新增：日期时间变化处理（重要！）====
    handleDateTimeChange(value) {
      // 当用户手动选择时间时，确保时间有效性
      if (value && this.timisngs === '2') {
        const selectedDate = new Date(value);
        const now = new Date();
        
        // 检查选择的日期是否是今天
        const selectedDay = new Date(selectedDate);
        selectedDay.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        // 只有当选择的是今天，并且时间早于当前时间时才进行调整
        if (selectedDay.getTime() === today.getTime() && selectedDate.getTime() < now.getTime()) {
          const adjustedDate = new Date();
          this.ScheduledRelease = adjustedDate;
        }
      }
    },
    picturePreview(data){
      this.previews = data
    },

    async download(){
      let aLink = document.createElement('a');
      aLink.download = '下载裁剪图片';
      let data = await this.$refs.picture.getBase64();
      aLink.href = data;
      aLink.click();
    },

    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog = false;
      if(e == 2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },
    onSubmit(type) {//创建
      this.loading = true;
      var from = new FormData();
      this.ScheduledRelease=this.timisngs==1?'':this.ScheduledRelease;
      from.append('fileName', this.imageFile);
      from.append('MaterialName', this.MaterialName);
      from.append('Label', this.Label);
      from.append('ItemKey', this.ItemKey);
      from.append('Type', type);
      from.append('MaterialKey', this.materialKey);
      from.append('CodeSnippet',this.$refs.ue.getUEContent());
      from.append('RoleID',sessionStorage.getItem('RoleID'));
      from.append('ScheduledRelease', this.ScheduledRelease);
      this.$Http_Post('management/articlePublishing', from, { 'Content-Type': 'multipart/form-data'}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.videopd = true;
          this.loading = false;
          this.Global.request_successful(res.Message);
          this.$router.go(-1);
        } else {
          this.loading = false;
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imageFile = file;
        this.Croppdialog=true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    videohandleChange(file, fileList) {
      if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        this.videoFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
      }
    },

    videohandleAvatarSuccess(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
    },

    videobeforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 8
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isLt2M
    },

    //进度条
    uploadVideoProcess(event, file, fileList) {

    },
  },
}
</script>
<style>
  .Video_release{background-color: #fff;width: 100%;
  }
  /* .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;} */
.avatar-uploader .el-upload:hover {border-color: #409eff;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
.avatar-uploader {position: absolute;top: 0px;left: 0px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
.scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
.scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
.editor-container{width: 750px;display: block;}
  .ue .el-form-item__content{line-height:1;}
</style>
